import { affixToWorldUp } from "../utils/three-utils";
import { findAncestorWithComponent } from "../utils/scene-graph";

AFRAME.registerComponent("enable-on-proximity", {
  schema: {
    distance: { default: 1 }
  },
  init() {
    // Get distance from camera to object
    this.enabled = false;
    this.distance = 0;
    this.camera = document.querySelector("#viewing-camera").object3DMap.camera;
    this.helperMat4 = new THREE.Matrix4();
    this.v1 = new THREE.Vector3();
    this.m1 = new THREE.Matrix4();
    this.up = new THREE.Vector3();
    this.backward = new THREE.Vector3();
    this.forward = new THREE.Vector3();
    this.camToObject = new THREE.Vector3();
    this.position = new THREE.Vector3();
    this.enableOnProximity = this.enableOnProximity.bind(this);
    this.lastTick = 0;
    this.mixerEl = findAncestorWithComponent(this.el, "animation-mixer");
    this.initPosition = new THREE.Vector3();
    this.initPosition.copy(this.el.object3D.position);
    this.distanceAux = new THREE.Vector3();
    this.camToObjectAux = new THREE.Vector3();
  },
  tick(now) {
    // Throttle to 5fps
    if (now - this.lastTick < 200) return;
    this.lastTick = now;

    const scene = this.el.sceneEl;
    if (!scene.is("entered")) return;

    this.enableOnProximity();
  },
  enableOnProximity() {
    const position = this.el.object3D.position;
    this.distance = this.camera.position.distanceTo(position);

    this.el.object3D.updateMatrices();
    this.camera.updateMatrices();

    affixToWorldUp(this.m1.copy(this.el.object3D.matrixWorld), this.m1).extractBasis(this.v1, this.up, this.backward);

    // it alters initial position of the object
    // position.setFromMatrixPosition(this.el.object3D.matrixWorld).add(this.v1.addVectors(this.up, this.backward));

    this.camToObject.subVectors(position, this.v1.setFromMatrixPosition(this.camera.matrixWorld));

    this.camToObjectAux.subVectors(this.initPosition, this.v1.setFromMatrixPosition(this.camera.matrixWorld));

    this.distanceAux = this.camToObjectAux.length();

    this.distance = this.camToObject.length();

    const distanceEval = this.distanceAux;
    if (distanceEval < this.data.distance && !this.enabled && this.el.object3D.visible) {
      this.enabled = true;

      if (this.el.components["loop-animation"]) {
        this.mixerEl?.components["animation-mixer"].setPausedComponent(false);
        this.el.setAttribute("loop-animation", { paused: false });
      }

      if (this.el.components["media-video"]) {
        this.el.components["media-video"].playVideo();
      }

      const insertedVideo = this.el.querySelector('[media-video]');
      if(insertedVideo) {
        insertedVideo.components["media-video"].playVideo();
      }
    } else if (distanceEval > this.data.distance && this.enabled) {
      this.enabled = false;

      if (this.el.components["loop-animation"]) {
        this.mixerEl?.components["animation-mixer"].setPausedComponent(true);
        this.el.components["loop-animation"].stopAnimation();
      }

      if (this.el.components["media-video"]) {
        this.el.components["media-video"].stop();
      }

      const insertedVideo = this.el.querySelector('[media-video]');
      if(insertedVideo) {
        insertedVideo.components["media-video"].stop();
      }
    }
  }
});
